<mat-drawer-container class="mat-drawer-container" [hasBackdrop]="false">
  <mat-drawer-content>
    <inbox-chat [viewModel]="(drawerMode$ | async) === 'over'"></inbox-chat>
  </mat-drawer-content>
  <mat-drawer
    class="details-drawer"
    role="region"
    position="end"
    [mode]="drawerMode$ | async"
    [opened]="isDrawerOpen$ | async"
  >
    <mat-toolbar class="inbox-info-drawer-toolbar">
      <mat-toolbar-row>
        <button class="mdc-icon-button mat-mdc-icon-button mat-unthemed mat-mdc-button-base" (click)="back()">
          <mat-icon>
            {{ (viewMode$ | async) === 'sidebar' || activeSideView === 'tickets' ? 'arrow_back' : 'close' }}
          </mat-icon>
        </button>

        <h1 class="toolbar-title">
          <ng-container *ngIf="activeSideView === 'tickets'">{{ 'INBOX.TICKETS.TITLE' | translate }}</ng-container>
          <ng-container *ngIf="activeSideView === 'details'">{{ 'INBOX.DETAILS.TITLE' | translate }}</ng-container>
        </h1>
      </mat-toolbar-row>
    </mat-toolbar>
    <ng-container *ngIf="activeSideView === 'details'">
      <inbox-conversation-details
        [showTickets]="isTicketsEnabled()"
        (ticketsClicked)="openTickets()"
      ></inbox-conversation-details>
    </ng-container>
    <ng-container *ngIf="activeSideView === 'tickets'">
      <inbox-ticket [conversationDetails]="details$ | async"></inbox-ticket>
    </ng-container>
  </mat-drawer>
</mat-drawer-container>
